export const adverbs = [
  {
    id: 'temporaladverbien',
    category: 'adverbien',
    level: 'A1',
    title: 'Temporaladverbien (Ndajfoljet e Kohës)',
    detailedContent: `
      <section>
        <p>Ndajfoljet e kohës (Zeitadverbien) tregojnë <b>kur</b> ndodh diçka. Ato i përgjigjen pyetjeve: <i>Wann?</i> (Kur?), <i>Wie lange?</i> (Sa gjatë?), dhe <i>Wie oft?</i> (Sa shpesh?).</p>

        <h3>1. Wann? (Kur?)</h3>
        <ul>
          <li><b>heute</b> (sot), <b>gestern</b> (dje), <b>morgen</b> (nesër).</li>
          <li><b>jetzt</b> (tani), <b>sofort</b> (menjëherë), <b>gleich</b> (së shpejti / pas pak).</li>
          <li><b>früher</b> (më parë), <b>später</b> (më vonë).</li>
        </ul>

        <h3>2. Wie oft? (Sa shpesh?)</h3>
        <p>Këto tregojnë frekuencën e një veprimi:</p>
        <ul>
          <li><b>immer</b> (gjithmonë), <b>meistens</b> (shumicën e kohës).</li>
          <li><b>oft</b> (shpesh), <b>manchmal</b> (nganjëherë).</li>
          <li><b>selten</b> (rrallë), <b>nie / niemals</b> (kurrë).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Ich gehe heute ins Kino.', alb: 'Sot shkoj në kinema. ("heute" tregon kur zhvillohet veprimi).' },
      { ger: 'Wir essen manchmal Pizza.', alb: 'Ne hamë nganjëherë pica. (Frekuenca = manchmal).' }
    ],
    exercises: []
  },
  {
    id: 'lokaladverbien',
    category: 'adverbien',
    level: 'A1',
    title: 'Lokaladverbien (Ndajfoljet e Vendit)',
    detailedContent: `
      <section>
        <p>Ndajfoljet e vendit tregojnë <b>ku</b> ndodh një aksion ose drejt cilit vend po bëhet një lëvizje. Pyetjet kryesore janë: <i>Wo?</i> (Ku?), <i>Wohin?</i> (Për ku?), dhe <i>Woher?</i> (Nga ku?).</p>

        <h3>1. Ndajfoljet statike (Wo?)</h3>
        <ul>
          <li><b>hier</b> (këtu), <b>da</b> (aty), <b>dort</b> (atje).</li>
          <li><b>oben</b> (lart), <b>unten</b> (poshtë).</li>
          <li><b>vorn(e)</b> (përpara), <b>hinten</b> (mbrapa).</li>
          <li><b>draußen</b> (jashtë), <b>drinnen</b> (brenda), <b>überall</b> (kudo).</li>
        </ul>

        <h3>2. Ndajfoljet e lëvizjes (Wohin / Woher)</h3>
        <p>Gjermanishtja ka një specifikë unike: përdorimin e "hin" dhe "her" bashkangjitur ndajfoljeve.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli Hin & Her:</strong> 
          <br><b>hin</b> = largim nga folësi (drejt asaj pikës atje).
          <br><b>her</b> = afrim drejt folësit (drejt meje).
        </div>
        <ul>
          <li><b>hinauf</b> (lart - larg meje), <b>herauf</b> (lart - drejt meje).</li>
          <li><b>hinein</b> / <b>rein</b> (brenda - po hyn atje), <b>heraus</b> / <b>raus</b> (jashtë - po del drejt meje).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Das Buch liegt dort auf dem Tisch.', alb: 'Libri ndodhet ATJE mbi tavolinë.' },
      { ger: 'Komm sofort her!', alb: 'Eja menjëherë KËTU (drejt meje)!' }
    ],
    exercises: [
      { question: 'Nëse shikon dikë të dalë nga shtëpia (ti je jashtë), cilën fjalë përdor?', options: ['Er kommt heraus', 'Er geht hinein'], correct: 0, explanation: 'Sepse ai po afron drejt teje jashtë: her (drejt meje) + aus (jashtë) = heraus (nga sytë e tu po del jashtë).' }
    ]
  },
  {
    id: 'modaladverbien',
    category: 'adverbien',
    level: 'A2',
    title: 'Modaladverbien (Ndajfoljet e Mënyrës)',
    detailedContent: `
      <section>
        <p>Këto tregojnë <b>mënyrën e qenies / si</b> po ndodh diçka. Ato i përgjigjen pyetjes: <i>Wie?</i> (Si?). Shpesh ato tregojnë qëndrimet e folësit ose shfaqim sasinë/nivelin e thelbit.</p>

        <h3>1. Cilësia / Ndjenjat</h3>
        <ul>
          <li><b>gern(e)</b> (me dëshirë/qejf). <i>Ich schwimme gern.</i></li>
          <li><b>leider</b> (për fat të keq). <i>Leider habe ich keine Zeit.</i></li>
          <li><b>vielleicht</b> (ndoshta). <i>Vielleicht regnet es später.</i></li>
          <li><b>hoffentlich</b> (shpresojmë). <i>Hoffentlich gewinnen wir.</i></li>
        </ul>

        <h3>2. Sasia dhe Intensiteti</h3>
        <ul>
          <li><b>sehr</b> (shumë - para mbiemrit). <i>Das ist sehr groß.</i></li>
          <li><b>besonders</b> (veçanërisht). <i>Das Auto ist besonders schnell.</i></li>
          <li><b>fast</b> (gati/pothuajse). <i>Ich bin fast fertig.</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'kausaladverbien',
    category: 'adverbien',
    level: 'B1',
    title: 'Kausaladverbien (Ndajfoljet e Shkakut)',
    detailedContent: `
      <section>
        <p>Ato formojnë lidhje llogjike thelbësore mes dy faktesh në të folur. Japin shkaqe thelbesore që zevendsojn të tëre fjalinë relative. I përgjigjen pyetjes <i>Warum?</i> (Pse?).</p>

        <h3>Më të përdorurat formalisht</h3>
        <ul>
          <li><b>darum / deshalb / deswegen</b> (për këtë arsye / pra). Lidhin dy fjali kryesore me pozicion 1. <br/><i>Es regnete, <b>deshalb</b> blieb ich zu Hause.</i> (Po binte shi, për këtë arsye (prandaj) qëndrova gajsit në shpi).</li>
          <li><b>trotzdem</b> (pavarësisht kësaj). Përdoret për kontraste a reagime të kundërtash faktike. <br/><i>Es ist kalt, <b>trotzdem</b> schwimmt er im See.</i></li>
          <li><b>nämlich</b> (më saktë / sepse / domethënë). Tregon sqarim. <i>Ich komme nicht mit. Ich bin nämlich müde.</i> (Un s'vij po domethan se jam lozur).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
